import {Injectable} from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Printed} from '../models/Printed';
import {Remito} from "../models/Remito";
import {catchError, throwError, Observable, map} from "rxjs";
import {RemitoCreationDetails} from "../models/RemitoCreationDetails";
import {ViewRemitos} from "../models/ViewRemitos";
import {FabFilterDescriptor} from "@fabric/components/table-filter/data-query";
import {PagedResponse} from "../models/PagedResponse";
import {PagedRequest} from "../models/PagedRequest";

@Injectable({
  providedIn: 'root'
})
export class RemitoService {
  private readonly remitoUrl = environment.remitoUrl;

  constructor(private readonly httpClient: HttpClient) {
  }

  addRemito(remito: Remito): Observable<string> {
    return this.httpClient.post<string>(this.remitoUrl, remito).pipe(
      catchError((err) => {
        console.log("ERROR! Add remito failed: ", err)
        return throwError(err);
      })
    );
  }

  getDetails(): Observable<RemitoCreationDetails> {
    return this.httpClient.get<RemitoCreationDetails>(this.remitoUrl + "/motivo-trans-dest-solicitante/lists");
  }

  getRemitoById(remitoNum: number, ptoEmision: string): Observable<Remito> {
    return this.httpClient.get<Remito>(this.remitoUrl + '/' + ptoEmision + '/' + remitoNum);
  }

  getAllRemitos(): Observable<ViewRemitos[]> {
    return this.httpClient.get<ViewRemitos[]>(this.remitoUrl).pipe(map(
        allRemitos => {
          return allRemitos.map((allRemitos) => {
            return ViewRemitos.transformViewRemitosData(allRemitos);
          })
        }),
      catchError(this.handleError));
  }

  downloadPdf(remitoNum: number): Observable<Blob> {
    return this.httpClient.get(this.remitoUrl + '/pdf/download/' + remitoNum, {responseType: 'blob'}).pipe(catchError(this.parseErrorBlob));
  }

  emailPdf(remitoNum: number): Observable<any> {
    return this.httpClient.get(this.remitoUrl + '/pdf/email/' + remitoNum).pipe(catchError(this.handleError));
  }

  parseErrorBlob(err: HttpErrorResponse): Observable<any> {
    const reader: FileReader = new FileReader();
    let jsonError = "";
    const obs = new Observable((observer: any) => {
      reader.onloadend = (e) => {
        console.log(JSON.parse((<any>e.target).result));
        observer.error(JSON.parse((<any>e.target).result));
        // alert("Error:\n" + (<any>e.target).result);
        observer.complete();
      }
    });
    reader.readAsText(err.error);
    return obs;
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  savePrintedRemitos(print: Printed): Observable<Printed> {
    return this.httpClient.post<Printed>(this.remitoUrl + '/printed', print);
  }


  updateRemitoStatus(updatedRemitos: Remito): Observable<Remito> {
    return this.httpClient.put<Remito>(this.remitoUrl, updatedRemitos);
  }

  cancelRemito(cancelRemito: ViewRemitos): Observable<Remito> {
    return this.httpClient.put<Remito>(this.remitoUrl + '/cancel', cancelRemito);
  }

  updateRemito(remito: Remito, nroRemito: number): Observable<Remito> {
    return this.httpClient.put<Remito>(this.remitoUrl + '/update/header/' + nroRemito, remito);
  }

  getAllRemitosPaged(page: number,
                     pageSize: number,
                     sortFields: string[],
                     sortDirection: 'asc' | 'desc' | '',
                     filters: FabFilterDescriptor[]): Observable<PagedResponse<ViewRemitos>> {
    const req = new PagedRequest();
    req.page = page;
    req.pageSize = pageSize;
    req.sortFields = sortFields;
    req.sortDirection = sortDirection;
    req.filters = filters;

    return this.httpClient.post<PagedResponse<ViewRemitos>>(this.remitoUrl + "/page", req)
      .pipe(
        map(
          res => {
            res.data = res.data.map((r) => {
              return ViewRemitos.transformViewRemitosData(r);
            })
            return res;
          }),
        catchError(this.handleError));
  }

}
